<template>
  <div v-if="isAdmin">
    <b-button variant="outline-primary" size="sm" @click="open = true">
      <b-icon icon="file-earmark-spreadsheet" class="mr-1"></b-icon>
      Выгрузка базы с финансами
    </b-button>

    <b-modal
      v-model="open"
      title="Выгрузка клиентской базы с финансами"
      size="md"
      :no-close-on-backdrop="loading"
      :hide-header-close="loading"
    >
      <p class="text-secondary small mb-3">
        Excel, одна строка - клиент: карточка (статус, менеджеры, даты поставок и заявок),
        поставки, выручка, затраты, GP и маржа по годам, итого и по каждому продукту.
        Суммы без НДС, как в отчёте «Финансовые показатели заказов». Заказ относится к году
        по дате погрузки, а если её нет - по дате создания.
      </p>
      <p class="text-secondary small mb-3">
        В выгрузку попадают все клиенты по текущим фильтрам портфеля (продукт, дата последней заявки, КАМ, Sales менеджер).
      </p>

      <div class="d-flex align-items-center">
        <span class="mr-2">Годы:</span>
        <b-form-select v-model="yearFrom" :options="yearOptions" size="sm" class="w-auto" :disabled="loading"></b-form-select>
        <span class="mx-2 text-secondary">-</span>
        <b-form-select v-model="yearTo" :options="yearOptions" size="sm" class="w-auto" :disabled="loading"></b-form-select>
      </div>
      <div v-if="yearsError" class="text-danger small mt-2">{{ yearsError }}</div>

      <template #modal-footer>
        <b-button variant="secondary" size="sm" :disabled="loading" @click="open = false">Отмена</b-button>
        <b-button variant="primary" size="sm" :disabled="loading || !!yearsError" @click="download">
          <b-spinner v-if="loading" small class="mr-1"></b-spinner>
          {{ loading ? "Формируем файл..." : "Скачать" }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { API_CLIENTS_PORTFOLIO_FINANCE_EXPORT } from "@/constants/api";

const FIRST_YEAR = 2020;
const MAX_YEARS = 5;

export default {
  data() {
    return {
      open: false,
      loading: false,
      yearFrom: 2025,
      yearTo: 2026,
    };
  },

  computed: {
    ...mapGetters("auth", ["currentUser"]),
    ...mapState("clientPortfolio", ["serviceId", "dateFrom", "dateTo", "kamIds", "salesManagerIds"]),

    isAdmin() {
      return !!(this.currentUser && this.currentUser.role && this.currentUser.role.includes("administrator"));
    },

    yearOptions() {
      const last = new Date().getFullYear() + 1;
      const years = [];
      for (let year = FIRST_YEAR; year <= last; year++) {
        years.push(year);
      }
      return years;
    },

    yearsError() {
      if (this.yearFrom > this.yearTo) {
        return "Начальный год больше конечного";
      }
      if (this.yearTo - this.yearFrom + 1 > MAX_YEARS) {
        return `Не больше ${MAX_YEARS} лет за одну выгрузку`;
      }
      return "";
    },
  },

  methods: {
    async download() {
      this.loading = true;
      try {
        const response = await axios.get(API_CLIENTS_PORTFOLIO_FINANCE_EXPORT, {
          params: {
            year_from: this.yearFrom,
            year_to: this.yearTo,
            service_id: this.serviceId || undefined,
            date_from: this.dateFrom || undefined,
            date_to: this.dateTo || undefined,
            kam_ids: this.kamIds.length ? this.kamIds : undefined,
            sales_manager_ids: this.salesManagerIds.length ? this.salesManagerIds : undefined,
          },
          responseType: "blob",
          timeout: 0,
        });

        const today = new Date().toLocaleDateString("ru-RU");
        const url = URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Клиентская база с финансами ${this.yearFrom}-${this.yearTo} (${today}).xlsx`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);

        this.open = false;
      } catch (e) {
        let message = "Не удалось сформировать выгрузку";
        // Ответ с ошибкой тоже пришёл как blob - достать текст
        if (e.response && e.response.data instanceof Blob) {
          try {
            const data = JSON.parse(await e.response.data.text());
            if (typeof data.error === "string") {
              message = data.error;
            }
          } catch (parseError) {
            // не JSON - оставить общее сообщение
          }
        }
        this.$toast.error(message);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
